module.exports = __webpack_public_path__ + "img/concrete.f88a5c8a.png";